import { parseJson } from '@gnsx/genesys.js';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = parseJson(process.env.NEXT_PUBLIC_FIREBASE_PROJECT_CONFIG || '{}');

// Lazy evaluated getters for Firebase services
let _app: ReturnType<typeof initializeApp> | null = null;
let _auth: ReturnType<typeof getAuth> | null = null;
let _db: ReturnType<typeof getFirestore> | null = null;
let _storage: ReturnType<typeof getStorage> | null = null;
let _realtime_db: ReturnType<typeof getDatabase> | null = null;

export const app = () => {
  if (!_app) {
    _app = initializeApp(firebaseConfig);
  }
  return _app;
};

export const auth = () => {
  if (!_auth) {
    _auth = getAuth(app());
  }
  return _auth;
};

export const db = () => {
  if (!_db) {
    _db = getFirestore(app());
  }
  return _db;
};

export const storage = () => {
  if (!_storage) {
    _storage = getStorage(app());
  }
  return _storage;
};

export const realtime_db = () => {
  if (!_realtime_db) {
    _realtime_db = getDatabase(app());
  }
  return _realtime_db;
};
